import { Chip } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { getGridDateOperators } from '@mui/x-data-grid';

import type { EngagementGridRow, WaiverGridRow } from '@/apps/engagement-letter-database/data/types';

import DateFilterInput from '../components/DashboardDataGrid/Filters/DateFilterInput/index';

// Date operators that use the DatePicker filter input.
const dateColumnOperators = getGridDateOperators().map((operator) => ({
  ...operator,
  InputComponent: DateFilterInput,
}));

const createColumns = (): GridColDef<EngagementGridRow>[] => [
  { field: 'clientName', headerName: 'Client Name', flex: 1 },
  { field: 'clientNumber', headerName: 'Client Number', flex: 1 },
  { field: 'responsibleAttorney', headerName: 'Responsible Attorney', flex: 1 },
  { field: 'practiceGroup', headerName: 'Practice', flex: 1 },
  {
    field: 'openDate',
    headerName: 'Open Date',
    flex: 1,
    type: 'date',
    filterOperators: dateColumnOperators,
    renderCell: (params) => (params.value ? (params.value as Date).toLocaleDateString() : ''),
  },
  {
    field: 'closedDate',
    headerName: 'Closed Date',
    flex: 1,
    type: 'date',
    filterOperators: dateColumnOperators,
    renderCell: (params) =>
      params.value ? (params.value as Date).toLocaleDateString() : <Chip label="Open" size="small" color="success" />,
  },
  {
    field: 'isExecuted',
    headerName: 'Executed',
    flex: 1,
    type: 'boolean',
    renderCell: (params) =>
      params.value ? (
        <Chip label="Yes" size="small" color="default" />
      ) : (
        <Chip label="No" size="small" color="warning" />
      ),
  },
];

export { createColumns, createWaiverColumns };

const createWaiverColumns = (): GridColDef<WaiverGridRow>[] => [
  { field: 'clientName', headerName: 'Client Name', flex: 1 },
  { field: 'clientNumber', headerName: 'Client Number', flex: 1 },
  { field: 'matterNumber', headerName: 'Matter Number', flex: 1 },
  { field: 'adverseClientName', headerName: 'Adverse Client', flex: 1 },
  { field: 'adverseContactSigner', headerName: 'Adverse Contact Signer', flex: 1 },
  {
    field: 'adverseLetterDate',
    headerName: 'Adverse Letter Date',
    flex: 1,
    type: 'date',
    filterOperators: dateColumnOperators,
    renderCell: (params) => (params.value ? (params.value as Date).toLocaleDateString() : ''),
  },
  { field: 'adverseAttorney', headerName: 'Adverse MLB Attorney', flex: 1 },
  { field: 'clientContact', headerName: 'Client Contact', flex: 1 },
  {
    field: 'clientLetterDate',
    headerName: 'Client Letter Date',
    flex: 1,
    type: 'date',
    filterOperators: dateColumnOperators,
    renderCell: (params) => (params.value ? (params.value as Date).toLocaleDateString() : ''),
  },
  { field: 'clientAttorney', headerName: 'Client MLB Attorney', flex: 1 },
  {
    field: 'multipleWaivers',
    headerName: 'Multiple Waivers',
    flex: 0.8,
    renderCell: (params) =>
      params.value === 'Yes' ? (
        <Chip label="Yes" size="small" color="info" />
      ) : (
        <Chip label="No" size="small" color="default" />
      ),
  },
];
